function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function uniqueKeys() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _toConsumableArray(new Set(values.filter(function (value) {
    return typeof value === 'string' && value;
  })));
}
function returnPolicy(app) {
  var _app$options;
  var modulePublicKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var options = (app === null || app === void 0 || (_app$options = app.options) === null || _app$options === void 0 ? void 0 : _app$options.bugs) || {};
  return {
    maintainers: uniqueKeys(options.maintainers),
    administrator: options.administrator_publickey || modulePublicKey || '',
    allowedAdders: uniqueKeys(options.allowed_adders),
    requireMaintainerForAdd: options.require_maintainer_for_add === true
  };
}
function isMaintainer(policy, signer) {
  return signer === policy.administrator || policy.maintainers.includes(signer);
}
function canCreateBug(policy, signer) {
  var reporter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!signer) return false;
  if (isMaintainer(policy, signer)) return true;
  if (policy.allowedAdders.includes(signer)) return true;
  if (policy.requireMaintainerForAdd) return false;
  return signer === reporter || policy.allowedAdders.length === 0;
}
function canUpdateBug(_policy, signer, bug) {
  // Mutations are intentionally permissionless; transaction handling verifies
  // the signer's signature before consulting this policy.
  return Boolean(signer && bug);
}
module.exports = {
  canCreateBug: canCreateBug,
  canUpdateBug: canUpdateBug,
  isMaintainer: isMaintainer,
  returnPolicy: returnPolicy
};